module.exports = __webpack_public_path__ + "static/media/urgent_outline_large.4b9a7d3d.svg";